import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import { Search, Close } from "@mui/icons-material";


function SelectDropdown({
  data,
  value,
  onValueChange,
  isSearchInputShown,
  depotDropdownOpenFlag,
  handleDepotDropdownOpenChange,
}) {
  const dispatch = useDispatch();
  
  const Data = data;
  const allDepotsOption = Data.shift();
  Data.sort((a, b) => a.name.localeCompare(b.name));
  Data.unshift(allDepotsOption);

  const [filteredData, setFilteredData] = useState(Data);

  const selectedDropdownClassName = value !== "All depots" && "selected-dropdownfield";

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(isDropdownOpenFlag(open));
  }, [open]);

  const onElementClicked = (item) => {
    onValueChange(item);
    setOpen((prevOpen) => !prevOpen);
    handleDepotDropdownOpenChange &&
      handleDepotDropdownOpenChange(!depotDropdownOpenFlag);
  };
  const onButton = () => {
    setOpen((prevOpen) => !prevOpen);
    handleDepotDropdownOpenChange &&
      handleDepotDropdownOpenChange(!depotDropdownOpenFlag);
  };

  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value)
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm === '') {
      setFilteredData(Data);
    } else {
      const filtered = Data.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm) && item.name !== 'ALL CLIENTS'
      );
      filtered.sort((a, b) => a.name.localeCompare(b.name));
      filtered.unshift(Data[0]);
      setFilteredData(filtered);
    }
  };

  return (
    <div ref={dropdownRef}>
      <div className="wrapper">
        <div
          className="button d-flex flex-row justify-content-between"
          onClick={() => onButton()}
        >
          <span className="depot-dropdown-value-style">{value}</span>
          {open ? (
            <span>
              <i className="bi bi-chevron-up chevron-up-arrow"></i>
            </span>
          ) : (
            <span>
              <i className="bi bi-chevron-down chevron-down-arrow"></i>
            </span>
          )}
        </div>
        {open && (
          <>

            <div className={`content`}>
              {isSearchInputShown &&
                <div style={{ position: "relative",background:"#0045d9" }}>
                  <input
                    style={{ position: "relative", width: "100%" }}
                    className="search-field-input"
                    type="text"
                    placeholder="Search by name..."
                    value={searchValue}
                    onChange={handleSearchInputChange}
                  />
                  {searchValue !== "" ? (
                    <Close
                      style={{ cursor: "pointer" }}
                      onClick={handleClearSearchText}
                      className="search-icon-depotpersonal-style"
                    />
                  ) : (
                    <Search className="search-icon-depotpersonal-style" />
                  )}
                </div>
              }
              {filteredData.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      value === item.name ? `${selectedDropdownClassName}` : ""
                    }
                    onClick={() => onElementClicked(item)}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default SelectDropdown;
